export default __webpack_public_path__ + "124ae9f7c00557e6e2e7646b1bef04b2.png";